import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ReconConversationEntity } from './recon-conversation.entity';
import { ReconInteractionEntity } from './recon-interaction.entity';

/**
 * Individual messages within a conversation.
 */
@Entity('recon_conversation_messages')
@Index('idx_recon_messages_conversation', ['conversationId'])
@Index('idx_recon_messages_sent', ['sentAt'])
export class ReconConversationMessageEntity extends BaseEntity {
	// Links
	@Column('int', { name: 'conversation_id', unsigned: true })
	public conversationId!: number;

	// Message
	/**
	 * Message direction.
	 * 'inbound' (from prospect) or 'outbound' (from us)
	 */
	@Column('varchar', { name: 'direction', length: 10 })
	public direction!: 'inbound' | 'outbound';

	@Column('varchar', {
		name: 'platform_message_id',
		length: 500,
		nullable: true,
	})
	public platformMessageId!: string | null;

	@Column('text', { name: 'content' })
	public content!: string;

	@Column('datetime', { name: 'sent_at', nullable: true })
	public sentAt!: Date | null;

	// For outbound messages: link to interaction if AI-generated
	@Column('int', { name: 'interaction_id', unsigned: true, nullable: true })
	public interactionId!: number | null;

	// Relations
	@ManyToOne(() => ReconConversationEntity)
	@JoinColumn({ name: 'conversation_id' })
	public conversation?: ReconConversationEntity;

	@ManyToOne(() => ReconInteractionEntity)
	@JoinColumn({ name: 'interaction_id' })
	public interaction?: ReconInteractionEntity;
}
